import React, { useState } from 'react'
import { getAuthToken } from '../../utils/auth'

const AdminSettings = () => {
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' })
  const [pwStatus, setPwStatus] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    setPwForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
    setPwStatus(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (pwForm.newPw !== pwForm.confirm) {
      setPwStatus({ success: false, error: 'New passwords do not match' })
      return
    }
    setIsSubmitting(true)

    try {
      const token = getAuthToken()
      const response = await fetch('/api/change-password.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
        body: JSON.stringify({ currentPassword: pwForm.current, newPassword: pwForm.newPw })
      })

      if (response.ok) {
        setPwStatus({ success: true })
        setPwForm({ current: '', newPw: '', confirm: '' })
      } else {
        const data = await response.json()
        setPwStatus({ success: false, error: data.error || 'Failed to update password' })
      }
    } catch {
      setPwStatus({ success: false, error: 'Network error. Please try again.' })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="admin-settings">
      <div className="settings-section">
        <h2>Settings</h2>
        <p>Manage your admin account preferences.</p>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <i className="fas fa-lock"></i>
          <div>
            <h3>Change Password</h3>
            <p>Update your admin password. Minimum 8 characters.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="settings-form">
          {pwStatus?.success && (
            <div className="settings-success">
              <i className="fas fa-check-circle"></i> Password updated successfully.
            </div>
          )}
          {pwStatus?.error && (
            <div className="admin-login-error">
              <i className="fas fa-exclamation-circle"></i> {pwStatus.error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="current">Current Password</label>
            <input
              type="password"
              id="current"
              name="current"
              value={pwForm.current}
              onChange={handleChange}
              required
              placeholder="Enter current password"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="newPw">New Password</label>
              <input
                type="password"
                id="newPw"
                name="newPw"
                value={pwForm.newPw}
                onChange={handleChange}
                required
                minLength={8}
                placeholder="Min. 8 characters"
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirm">Confirm New Password</label>
              <input
                type="password"
                id="confirm"
                name="confirm"
                value={pwForm.confirm}
                onChange={handleChange}
                required
                placeholder="Repeat new password"
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? (
                <><div className="spinner"></div>Updating...</>
              ) : (
                <><i className="fas fa-save"></i>Update Password</>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AdminSettings
